


































































import { defineComponent } from "@vue/composition-api";
import BaseSpinner from "@/components/BaseSpinner";

export default defineComponent({
  name: "BaseStepper",
  components: { BaseSpinner },
  props: {
    steps: { type: Number, required: true },
    current: { type: Number, default: 1 },
    loading: { type: Boolean, default: false },
    safeMode: { type: Boolean, default: false },
    hideHeader: { type: Boolean, default: false },
  },
  data() {
    return {
      currentStep: this.current,
    };
  },
  computed: {
    hasNext(): boolean {
      return this.currentStep < this.steps;
    },

    hasPrev(): boolean {
      return this.currentStep > 1;
    },
  },
  watch: {
    current(current: number) {
      this.next(current);
    },
  },
  methods: {
    next(step?: number) {
      if (typeof step !== "number") step = undefined;
      if (step || this.hasNext) this.currentStep = step ? step : this.currentStep + 1;
      this.$emit("changeStep", this.currentStep);
    },

    prev() {
      if (this.hasPrev) this.currentStep = this.currentStep - 1;
      this.$emit("changeStep", this.currentStep);
    },
  },
});
